var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "margin-bottom": "15px" } },
    [
      _c(
        "el-card",
        { attrs: { header: "投保须知" } },
        [
          _c(
            "el-container",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.isLoadingPdf,
                  expression: "isLoadingPdf",
                },
              ],
              ref: "pdf",
              style: _vm.setHeight,
            },
            [
              _c(
                "el-main",
                [
                  _c(
                    "el-alert",
                    {
                      staticStyle: { "margin-bottom": "10px" },
                      attrs: { closable: false, type: "error" },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-size": "1.25em",
                            "font-weight": "bold",
                          },
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t为保障您的合法权益，请您仔细阅读以下各部分内容，重要内容将以红色加粗字体为您标记，请务必知晓。如有疑问，请先联系客服人员确认无误后再行投保。\n\t\t\t\t\t"
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm.currentPosition === -1
                    ? _c("insured-notice", {
                        attrs: {
                          insureType: _vm.insureType,
                          productId: _vm.productId,
                        },
                      })
                    : _vm._e(),
                  _vm.isShowPdf
                    ? _c("div", [
                        _vm.currentPosition >= 0
                          ? _c(
                              "div",
                              _vm._l(_vm.currentPdfPages, function (index) {
                                return _c("pdf", {
                                  key: index,
                                  staticStyle: {
                                    "margin-left": "230px",
                                    "margin-right": "230px",
                                  },
                                  attrs: {
                                    page: index,
                                    src: _vm.pdfPath[_vm.currentPosition],
                                  },
                                  on: {
                                    progress: _vm.onPdfProcess,
                                    "page-loaded": _vm.onOverReload,
                                  },
                                })
                              }),
                              1
                            )
                          : _vm._e(),
                        _vm.currentPdfPages > 0 || _vm.currentPosition === -1
                          ? _c("div", [
                              _c("div", { staticClass: "customPage" }, [
                                _vm._v(
                                  _vm._s(_vm.currentPosition + 2) +
                                    "/" +
                                    _vm._s(_vm.pdfPath.length + 1)
                                ),
                              ]),
                              !_vm.isHideBtn
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "justify-content": "center",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            disabled:
                                              _vm.currentPosition === -1,
                                            plain: "",
                                            type: "default",
                                          },
                                          on: { click: _vm.onPageLast },
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t上一页\n\t\t\t\t\t\t\t"
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          staticStyle: { width: "140px" },
                                          attrs: {
                                            disabled: _vm.currentNum > 0,
                                            type: "primary",
                                          },
                                          on: { click: _vm.onPageNext },
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t" +
                                              _vm._s(
                                                _vm.currentNum > 0
                                                  ? _vm.currentNum + "s后可关闭"
                                                  : "我已逐条阅读并同意"
                                              ) +
                                              "\n\t\t\t\t\t\t\t"
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.isMeiYaC(_vm.insureType, _vm.productId)
        ? _c(
            "div",
            [
              _c(
                "el-card",
                {
                  staticStyle: { "margin-top": "20px" },
                  attrs: { header: "投保人声明及确认" },
                },
                [
                  _c("div", { staticClass: "insure_confirm" }, [
                    _vm._v(
                      "\n\t\t\t\t1、本公司/单位兹申请“美亚1-6类团意险（C款）”，并声明以上陈述及各项细节属真实无讹。本公司/单位同意，本投保申请将会构成投保人与美亚财产保险有限公司（以下简称“贵公司”）所签署的保险合同的依据。本公司/单位理解并同意，贵公司承担保险责任须经投保人缴付本合同项下的约定保险费并经贵公司签发保险单确认承保后开始。\n\t\t\t\t2、本公司/单位确认：本公司/单位已经认真阅读保险合同规定，尤其是免除保险人责任的规定，并对贵公司就保险合同的内容说明和提示完全理解，没有异议，申请投保。本公司/单位知晓所有保险责任均以保险合同所载为准。\n\t\t\t\t3、本公司/单位确认：本公司已获得各被保险人的各项同意（包括各被保险人对本保险项下身故保障投保事宜以及保险金额的同意），由本公司为其投保本团体保险；同时本公司/单位同意，如本公司在保险有效期内按约定解除保险合同的，将告知各被保险人。\n\t\t\t\t4、本公司/单位确认：本公司/单位已经认真阅读投保须知中所列的所有投保条件，并如实告知所有投保前提条件；本公司/单位同意，在订立保险合同过程中如未如实填写本投保申请或未如实告知被保险人的有关情况（包括但不限于投保条件的确认），应视为本公司/单位故意未依法履行如实告知义务，由此可能导致该投保无效或贵公司不承担保险责任。\n\t\t\t\t5、本公司/单位同意凡申请投保的员工资料或之后的变更资料，均视为本投保申请的一部分，也是贵公司核保的基础。\n\t\t\t\t6、本公司/单位确认：原则上，本公司/单位通过对公账户按照贵公司要求的路径交纳保险费。若因客观原因无法通过对公账户交纳，本公司/单位将授权第三人代为交纳保险合同项下的保险费，并在投保过程中提供相关授权人及支付账户信息。如保险合同项下发生退费，则贵公司可按原保费交纳路径，将相关保费退还至原保费交纳账户；在本公司/单位授权第三人代为交纳保险费的情形，如贵公司按前述约定将相关保费退还至非本公司/单位账户的，应视为贵公司已履行保险合同项下保费退还义务。\n\t\t\t\t7、本公司/单位明白：因履行本合同或其附加合同发生的争议，由争议所涉各方协商解决。协商不成的，应依法向本公司签发保险合同的分支机构所在地有管辖权的人民法院起诉。\n\t\t\t\t8、本公司/单位确认已阅读并理解贵公司在官网发布的隐私政策（https://www.aig.com.cn/individuals/privacy-notice），同意向所有被保险人获得符合《个人信息保护法》下规定的各项有效同意，以便贵公司根据该隐私政策，处理（包括不限于收集、使用、向境内外第三方提供）被保险人、被保险人所提供的其他个人的个人信息（该信息无论是从投保单还是其他地方获得），以实现该隐私政策中“我们使用个人信息的目的”项下所述的目的。本公司/单位同意，从被保险人处获得的前述有效同意包括就所有下述情形的单独同意：\n\t\t\t\t(1)贵公司根据隐私政策中“我们使用个人信息的目的”项下所述的目的处理个人信息，这些信息可能含有贵公司隐私政策中“我们收集并持有的个人信息”项下所述的敏感个人信息。《个人信息保护法》规定，敏感个人信息包括生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹、不满十四周岁未成年人的个人信息；\n\t\t\t\t(2)贵公司将个人信息披露或提供给贵公司隐私政策中“个人信息的分享方”项下所述的第三方；\n\t\t\t\t(3)贵公司根据贵公司隐私政策中“个人信息处理地点”项下所述在中国境外处理个人信息，并将个人信息提供给隐私政策中“个人信息的分享方”项下所述中国境外的接收方。\n\t\t\t\t如果本公司/单位提供了其他个人的个人信息，我们确认已向其他个人提供了贵公司的隐私政策，并获得了其就贵公司根据隐私政策处理其个人信息的有效同意。所述同意包括在处理其敏感个人信息、向第三方披露其个人信息、向中国境外接收方提供其个人信息以及在中国境外处理其个人信息方面的单独同意。\n\t\t\t\t本公司/单位同时同意，贵公司可按照前述方式和目的处理本公司/单位/和/或被保险人的、与提供保险服务相关的其他信息。\n\t\t\t"
                    ),
                  ]),
                ]
              ),
              _c(
                "el-card",
                {
                  staticStyle: { "margin-top": "20px" },
                  attrs: { header: "责任免除" },
                },
                [
                  _c("div", { staticClass: "insure_confirm" }, [
                    _vm._v(
                      "\n\t\t\t\t本保险适用的主要责任免除如下，其他责任免除条款以与美亚财产保险有限公司正式订立保险合同的规定为准。\n\t\t\t\t"
                    ),
                    _c("div", { staticClass: "title_bold" }, [
                      _vm._v(
                        "美亚附加经济制裁责任免除条款（注册编号：C00003931922019052907382）"
                      ),
                    ]),
                    _vm._v("\n\t\t\t\t兹经双方理解并同意，\n\t\t\t\t"),
                    _c("span", { staticClass: "title_bold_custom" }, [
                      _vm._v(
                        "\n\t\t\t\t\t若本公司/保险人在本保险合同项下提供任何保险保障、利益或支付任何保险赔偿金会导致本公司/保险人违反联合国决议项下的任何制裁、禁止性或限制性规定，或者违反中华人民共和国或美国颁布的任何经济贸易制裁、法律法规，则本公司/保险人在本保险合同项下不提供前述保险保障、利益，亦不支付前述保险赔偿金。\n\t\t\t\t"
                      ),
                    ]),
                    _c("div", { staticClass: "title_bold" }, [
                      _vm._v(
                        "\n\t\t\t\t\t美亚附加仅承保境内意外事故条款（2021年第二版）（互联网专属）（注册编号：C00003932322021122437063）\n\t\t\t\t"
                      ),
                    ]),
                    _vm._v(
                      "\n\t\t\t\t兹经双方理解并同意，本合同仅承保于境内发生的意外事故。本合同所称的境内是指中国大陆地区，\n\t\t\t\t"
                    ),
                    _c("span", { staticClass: "title_bold_custom" }, [
                      _vm._v("不包括台湾省、香港及澳门特别行政区。"),
                    ]),
                    _vm._v(
                      "\n\t\t\t\t兹经双方进一步理解并同意，本合同所称的医院仅指境内经国家卫生部门评审确定的二级以上（含二级）公立医院，\n\t\t\t\t"
                    ),
                    _c("span", { staticClass: "title_bold_custom" }, [
                      _vm._v(
                        "\n\t\t\t\t\t不包括任何精神病院、养老机构、康复医院、诊所、天然治疗所，以及主要作为护理、疗养、戒酒、戒毒或类似目的的医疗机构。\n\t\t\t\t"
                      ),
                    ]),
                    _c("div", { staticClass: "title_bold" }, [
                      _vm._v(
                        "\n\t\t\t\t\t美亚附加特种作业限制条款（2021年第二版）（互联网专属）（注册编号：C00003932322021122437203）\n\t\t\t\t"
                      ),
                    ]),
                    _vm._v(
                      "\n\t\t\t\t兹经双方理解并同意，被保险人在保险期间内进行任何特种作业操作前，应依法取得规定的特种作业证书。\n\t\t\t\t"
                    ),
                    _c("span", { staticClass: "title_bold_custom" }, [
                      _vm._v(
                        "\n\t\t\t\t\t若被保险人未依法取得规定的特种作业证书而进行特种作业操作的，则对于其因该特种作业操作导致的任何保险事故，本公司不承担任何保险责任。\n\t\t\t\t"
                      ),
                    ]),
                    _c("div", { staticClass: "title_bold" }, [
                      _vm._v(
                        "\n\t\t\t\t\t美亚附加特定职业类别人员高处作业条款（2021年第二版）（互联网专属）（注册编号：C00003932322021122437123）\n\t\t\t\t"
                      ),
                    ]),
                    _c("span", { staticClass: "title_bold_custom" }, [
                      _vm._v(
                        "\n\t\t\t\t\t任何在下列期间发生的意外事故，或出现下列任一情形时，本公司不承担任何保险责任：\n\t\t\t\t"
                      ),
                    ]),
                    _c("br"),
                    _c("span", { staticClass: "title_bold_custom" }, [
                      _vm._v("（1）被保险人从事高处作业时未系绑安全带。"),
                    ]),
                    _c("br"),
                    _c("span", { staticClass: "title_bold_custom" }, [
                      _vm._v(
                        "\n\t\t\t\t\t（2）被保险人在从事距坠落高度基准面5米及以上高处作业时未取得对应的特种作业证书。\n\t\t\t\t"
                      ),
                    ]),
                    _c("br"),
                    _c("div", { staticClass: "title_bold" }, [
                      _vm._v(
                        "美亚附加被保险人资格条款（2022 年第一版）（注册编号：C00003931922022103111811）"
                      ),
                    ]),
                    _vm._v("\n\t\t\t\t兹经双方理解并同意，\n\t\t\t\t"),
                    _c("span", { staticClass: "title_bold_custom" }, [
                      _vm._v("本合同仅承保符合约定投保资格的人员"),
                    ]),
                    _vm._v(
                      "\n\t\t\t\t，所述约定投保资格以投保单或投保申请载明的为准。\n\t\t\t\t"
                    ),
                    _c("span", { staticClass: "title_bold_custom" }, [
                      _vm._v(
                        "\n\t\t\t\t\t如保险公司在本合同订立后或在本合同有效期内发现任何投保人员不符合约定投保资格的，则保险公司有权依据合同约定取消该人员的被保资格，全额无息退还该人员已缴付的保险费，并对于取消其被保资格前所发生的保险事故不承担任何保险责任。\n\t\t\t\t"
                      ),
                    ]),
                    _c("div", { staticClass: "title_bold" }, [
                      _vm._v(
                        "美亚附加不承保特定医院条款（2022年第一版）（注册编号：C00003931922022112966381）"
                      ),
                    ]),
                    _vm._v("\n\t\t\t\t兹经双方理解并同意，\n\t\t\t\t"),
                    _c("span", { staticClass: "title_bold_custom" }, [
                      _vm._v(
                        "\n\t\t\t\t\t《美亚附加意外每日住院津贴团体收入保障保险》项下所称的医院不包括北京市（平谷区、密云区、怀柔区）、天津市（滨海新区、静海区）、福建省南平市、安徽省宿州市、河北省（三河市、廊坊市、青龙县、兴隆县）的所有医院；福建省宁德市古田县医院；河北省承德市第六医院、邯郸市第一医院、馆陶县人民医院、元氏县中医院；河南省（开封市、信阳市、新密市、内黄县、通许县）所有医院，河南省新乡市中医院、新乡市第二人民医院、焦作市第五人民医院、许昌县人民医院、商水县人民医院、濮阳县第二人民医院、鹤壁煤业（集团）有限责任公司总医院；山东省（莱州市、栖霞市、威海市、金乡县、禹城）所有医院，山东滨州市中心医院、鱼台县人民医院、青岛市即墨区中医院、荣成市中医院、烟台市中医医院、聊城市中医医院；四川省宜宾市所有医院、雅安市雨城区人民医院、雅安市第二人民医院、富顺县中医医院、绵阳市人民医院、泸州市纳溪区人民医院、内江市第四人民医院、阿坝州林业中心医院、遂宁市大英县中医院；甘肃省民勤县人民医院、宁县人民医院；山西省运城市盐湖区人民医院；黑龙江鸡西市所有医院，黑龙江省中医医院、牡丹江市中医院、牡丹江市第二人民医院、哈尔滨市第一医院、五大连池市第一人民医院；吉林省四平市所有医院，吉林省中医医院、通化市人民医院、长春市中心医院；辽宁省铁岭市所有医院，辽宁省中医医院；海南省第三人民医院。\n\t\t\t\t"
                      ),
                    ]),
                    _c("div", { staticClass: "title_bold" }, [
                      _vm._v(
                        "\n\t\t\t\t\t美亚附加被保险人职业类别处理规则条款（2022年第一版）（注册编号：C00003931922022112966391）\n\t\t\t\t"
                      ),
                    ]),
                    _vm._v(
                      "\n\t\t\t\t兹经双方理解并同意，本合同所承保的被保险人的职业类别以投保时约定的为准。投保人在为被保险人申请投保时，应按被保险人的实际职业类别填写，如被保险人工作涉及多个职业类别，则应以职业类别最高的职业为准。若申报的被保险人的职业类别不真实，则视为投保人故意未依法履行如实告知义务，并按照下列规定处理：\n\t\t\t\t（1）\n\t\t\t\t"
                    ),
                    _c("span", { staticClass: "title_bold_custom" }, [
                      _vm._v(
                        "\n\t\t\t\t\t如该被保险人的实际职业类别为申请投保时本合同约定不接受投保的职业类别，则其被保资格将被取消；对于取消其被保资格前所发生的保险事故，本公司不承担任何保险责任。\n\t\t\t\t"
                      ),
                    ]),
                    _vm._v(
                      "\n\t\t\t\t除本合同另有约定外，本公司在前述取消该被保险人被保资格的情形下将退还其项下相应的未满期保险费。\n\t\t\t\t（2）如该被保险人的实际职业类别为申请投保时本合同约定接受投保的职业类别，但高于为其所申报保险计划对应的职业类别，则该被保险人发生保险事故后，无论该保险事故是否与职业类别相关，本公司根据保险合同约定对其承担的赔偿金额均按以下公式计算：\n\t\t\t\t"
                    ),
                    _c("span", { staticClass: "title_bold_custom" }, [
                      _vm._v(
                        "\n\t\t\t\t\t实际赔偿金额=按保险合同约定核定的赔偿金额*（实际交纳保险费/实际职业类别对应的应交保险费）*70%\n\t\t\t\t"
                      ),
                    ]),
                    _vm._v(
                      "\n\t\t\t\t如任何被保险人在保险期间内职业类别发生任何变更，投保人或该被保险人应于变更后十个工作日内书面通知本公司。本公司收到投保人或该被保险人的通知后，有权按下列规定调整该被保险人的承保条件或拒绝接受该被保险人继续成为本合同的被保险人：（1）如其变更后的职业类别相比变更前风险程度降低的，则本公司按日比例退还自其变更职业类别之日起相应保险费的差额；（2）如其变更后的职业类别相比变更前风险增加但仍属于本合同约定接受投保的职业类别的，投保人应按日比例补缴自该被保险人变更职业类别之日起相应保险费的差额；\n\t\t\t\t（3）\n\t\t\t\t"
                    ),
                    _c("span", { staticClass: "title_bold_custom" }, [
                      _vm._v(
                        "\n\t\t\t\t\t如其变更后的职业类别为本合同约定不接受投保的职业类别，则自该被保险人变更职业类别之日起，本公司不再接受该被保险人继续成为本合同的被保险人，其被保资格将于变更职业类别之日二十四时丧失，\n\t\t\t\t"
                      ),
                    ]),
                    _vm._v(
                      "\n\t\t\t\t本公司将按承保日比例退还该被保险人未满期保险费。\n\t\t\t\t投保人或被保险人未履行上述通知义务的，本公司按照下列规定进行处理：\n\t\t\t\t"
                    ),
                    _c("span", { staticClass: "title_bold_custom" }, [
                      _vm._v(
                        "\n\t\t\t\t\t（1）如其变更后的职业类别为本合同约定不接受投保的职业类别，则其被保资格于变更职业类别之日二十四时丧失；对于其丧失被保资格后所发生的保险事故，本公司不承担任何保险责任；\n\t\t\t\t"
                      ),
                    ]),
                    _vm._v(
                      "\n\t\t\t\t（2）如其变更后的职业类别相比变更前风险增加但仍属于本合同约定接受投保的职业类别，则对于该被保险人在职业类别变更后发生的保险事故，本公司根据保险合同约定对其承担的赔偿金额均按以下公式计算：\n\t\t\t\t"
                    ),
                    _c("span", { staticClass: "title_bold_custom" }, [
                      _vm._v(
                        "\n\t\t\t\t\t实际赔偿金额=按保险合同约定核定的赔偿金额*（实际交纳保险费/变更后职业类别对应的应交保险费）*70%\n\t\t\t\t"
                      ),
                    ]),
                    _c("div", { staticClass: "title_bold" }, [
                      _vm._v(
                        "\n\t\t\t\t\t美亚团体意外伤害保险（2021年第一版）（互联网专属）（注册编号：C00003932312021121719483）\n\t\t\t\t"
                      ),
                    ]),
                    _c("div", { staticClass: "title_bold_custom" }, [
                      _vm._v(
                        "\n\t\t\t\t\t任何在下列期间发生的或由下列原因造成的被保险人的伤害，或出现下列任一情形时，本公司不负任何赔偿责任：\n\t\t\t\t\t（1）战争、军事行动、暴乱、罢工、武装叛乱或任何形式的恐怖活动。\n\t\t\t\t\t（2）任何生物、化学、原子能武器，原子能或核能装置所造成的爆炸、灼伤或辐射。\n\t\t\t\t\t（3）投保人的故意行为；或被保险人无论当时神志是否清醒，自致伤害或自杀。 （4）因被保险人故意行为\n\t\t\t\t\t"
                      ),
                      _c("span", { staticStyle: { "font-weight": "normal" } }, [
                        _vm._v("（见义勇为行为除外）"),
                      ]),
                      _vm._v(
                        "\n\t\t\t\t\t而导致的打斗、被袭击或被谋杀。\n\t\t\t\t\t（5）被保险人因从事违法犯罪的活动或因拒捕而导致的伤害；以及因遭受司法当局拘禁或被判入狱期间。\n\t\t\t\t\t（6）被保险人因酗酒或受酒精、毒品、管制药物的影响而导致的意外。 （7）被保险人因精神错乱或失常而导致的意外。\n\t\t\t\t\t（8）被保险人酒后驾车、无照驾驶或驾驶无有效行驶证的机动交通工具。\n\t\t\t\t\t（9）被保险人罹患艾滋病（AIDS）或感染艾滋病病毒（HIV）期间（上述定义，应按世界卫生组织所订的定义为准。若在被保险人的血液样本中发现上述病毒或其抗体，则认定已受该病毒感染）。\n\t\t\t\t\t（10）被保险人置身于任何飞机或空中运输工具\n\t\t\t\t\t"
                      ),
                      _c("span", { staticStyle: { "font-weight": "normal" } }, [
                        _vm._v("（以乘客身份搭乘民用或商业航班者除外）"),
                      ]),
                      _vm._v(
                        "\n\t\t\t\t\t期间。 （11）先天性畸形。 （12）受保前已存在的受伤及其并发症。\n\t\t\t\t\t（13）被保险人进行赛马、潜水、滑水、滑雪、滑翔翼、跳伞、攀岩运动、摔跤、柔道、空手道、跆拳道、马术、武术、拳击的运动或特技表演。\n\t\t\t\t\t（14）被保险人参与任何职业或半职业的体育运动。 （15）被保险人进行各种车辆表演、车辆竞赛或练习、驾驶卡丁车。\n\t\t\t\t\t（16）被保险人于海军、空军、陆军服军役或以警察身份执行任务期间。\n\t\t\t\t\t（17）被保险人从事采矿业、地下作业、山洞作业、水上作业、五米以上高处作业的职业活动期间。\n\t\t\t\t\t（18）妊娠、流产、分娩及由此引起的伤害；性传播疾病引起的伤害；美容手术、外科整形手术或其他医疗导致的伤害。\n\t\t\t\t\t（19）细菌或病毒感染\n\t\t\t\t\t"
                      ),
                      _c("span", { staticStyle: { "font-weight": "normal" } }, [
                        _vm._v("（但因意外伤害致有伤口而发生感染者除外）"),
                      ]),
                      _vm._v("\n\t\t\t\t\t、食物中毒。\n\t\t\t\t"),
                    ]),
                    _c("div", { staticClass: "title_bold" }, [
                      _vm._v(
                        "\n\t\t\t\t\t美亚附加意外医药补偿团体医疗保险（2021年第三版）（互联网专属）（注册编号：C00003932522021122436873）\n\t\t\t\t"
                      ),
                    ]),
                    _c("div", { staticClass: "title_bold_custom" }, [
                      _vm._v(
                        "\n\t\t\t\t\t主合同中所有责任免除条款均适用于本附加合同，若主合同中责任免除条款与本条款有相抵触之处，则应以本条款为准。\n\t\t\t\t\t任何在下列期间发生的或由下列原因导致的医药费用，本公司不负赔偿责任：\n\t\t\t\t\t（1）任何原因进行的牙齿保养、牙齿修复、牙齿整形或牙齿植种；非因意外事故进行的任何牙科检查、治疗或手术，以及任何进食活动（包括咀嚼或啃咬）引发的牙科治疗；对非自然牙进行的任何治疗。\n\t\t\t\t\t（2）屈光不正；任何非因意外事故而进行的眼科检查、视力矫正，以及因矫正视力而作的眼科验光检查。\n\t\t\t\t\t（3）一般的身体检查\n\t\t\t\t\t"
                      ),
                      _c("span", { staticStyle: { "font-weight": "normal" } }, [
                        _vm._v("（不包括因意外事故进行的牙科和眼科检查）"),
                      ]),
                      _vm._v(
                        "\n\t\t\t\t\t、疗养、特别护理或静养、康复性治疗或心理治疗。 （4）脊椎病。\n\t\t\t\t\t（5）中草药、中药材或任何传统中医治疗，传统中医治疗包括但不限于推拿、按摩、指压治疗、足科治疗、营养师治疗、理疗、针法、灸法、针灸、顺势治疗、整骨治疗。\n\t\t\t\t\t（6）任何在中医科、理疗科、康复科进行的治疗。\n\t\t\t\t\t（7）任何妊娠、流产、分娩、不孕不育症、避孕或绝育手术、美容手术、外科整形手术。\n\t\t\t\t\t（8）任何过敏反应、药物过敏或其他医疗导致的伤害。 （9）未取得医生的证明。\n\t\t\t\t\t（10）中国大陆境内医院自主制定价格并在特定区域内提供的特需医疗服务，包括但不限于特需门诊、特需病区、国际医疗、干部病房的相关医疗服务。\n\t\t\t\t"
                      ),
                    ]),
                    _c("div", { staticClass: "title_bold" }, [
                      _vm._v(
                        "\n\t\t\t\t\t美亚附加意外医药补偿团体医疗保险（2022年第三版）（互联网专属）（注册编号：C00003932522022051700001）\n\t\t\t\t"
                      ),
                    ]),
                    _c("div", { staticClass: "title_bold_custom" }, [
                      _vm._v(
                        "\n\t\t\t\t\t主合同中所有责任免除条款均适用于本附加合同，若主合同中责任免除条款与本条款有相抵触之处，则应以本条款为准。\n\t\t\t\t\t任何在下列期间发生的或由下列原因导致的医药费用，本公司不负赔偿责任：\n\t\t\t\t\t（1）任何原因进行的牙齿保养、牙齿修复、牙齿整形或牙齿植种；非因意外事故进行的任何牙科检查、治疗或手术，以及任何进食活动（包括咀嚼或啃咬）引发的牙科治疗；对非自然牙进行的任何治疗。\n\t\t\t\t\t（2）屈光不正；任何非因意外事故而进行的眼科检查、视力矫正，以及因矫正视力而作的眼科验光检查。\n\t\t\t\t\t（3）一般的身体检查\n\t\t\t\t\t"
                      ),
                      _c("span", { staticStyle: { "font-weight": "normal" } }, [
                        _vm._v("（不包括因意外事故进行的牙科和眼科检查）"),
                      ]),
                      _vm._v(
                        "\n\t\t\t\t\t、疗养、特别护理或静养、康复性治疗或心理治疗。 （4）脊椎病。\n\t\t\t\t\t（5）中草药、中药材或任何传统中医治疗，传统中医治疗包括但不限于推拿、按摩、指压治疗、足科治疗、营养师治疗、理疗、针法、灸法、针灸、顺势治疗、整骨治疗。\n\t\t\t\t\t（6）任何在中医科、理疗科、康复科进行的治疗。\n\t\t\t\t\t（7）任何妊娠、流产、分娩、不孕不育症、避孕或绝育手术、美容手术、外科整形手术或任何非必要的手术。\n\t\t\t\t\t（8）任何过敏反应、药物过敏或其他医疗导致的伤害。 （9）未取得医生的证明。\n\t\t\t\t\t（10）中国大陆境内医院自主制定价格并在特定区域内提供的特需医疗服务，包括但不限于特需门诊、特需病区、国际医疗、干部病房的相关医疗服务。\n\t\t\t\t\t（11）中国大陆境内当地社会基本医疗保险管理部门或其他公费医疗管理部门规定报销范围外的诊疗项目和药品、检查、治疗、材料等费用，\n\t\t\t\t\t"
                      ),
                      _c("span", { staticStyle: { "font-weight": "normal" } }, [
                        _vm._v("但在境外医院发生的医药费用除外。"),
                      ]),
                    ]),
                    _c("div", { staticClass: "title_bold" }, [
                      _vm._v(
                        "\n\t\t\t\t\t美亚附加意外每日住院津贴团体收入保障保险（2021年第一版）（注册编号：C00003931922021072908971）\n\t\t\t\t"
                      ),
                    ]),
                    _c("div", { staticClass: "title_bold_custom" }, [
                      _vm._v(
                        "\n\t\t\t\t\t主合同中责任免除条款均适用于本附加合同，若主合同中责任免除条款与本条款有相抵触之处，则应以本条款为准。\n\t\t\t\t\t任何在下列期间发生的，或由下列原因直接、间接地造成被保险人入住医院，或出现下列任一情形时，本公司不负任何赔偿责任：\n\t\t\t\t\t（1）任何原因进行的牙齿保养、牙齿修复、牙齿整形或牙齿植种；非因意外事故进行的任何牙科检查、治疗或手术，以及任何进食活动（包括咀嚼或啃咬）引发的牙科治疗；对非自然牙进行的任何治疗。\n\t\t\t\t\t（2）屈光不正；任何非因意外事故而进行的眼科检查、视力矫正，以及因矫正视力而作的眼科验光检查。\n\t\t\t\t\t（3）一般的身体检查\n\t\t\t\t\t"
                      ),
                      _c("span", { staticStyle: { "font-weight": "normal" } }, [
                        _vm._v("（不包括因意外事故进行的牙科和眼科检查）"),
                      ]),
                      _vm._v(
                        "\n\t\t\t\t\t、疗养、特别护理或静养、康复性治疗或心理治疗。 （4）脊椎病。\n\t\t\t\t\t（5）中草药、中药材或任何传统中医治疗，传统中医治疗包括但不限于推拿、按摩、指压治疗、足科治疗、营养师治疗、理疗、针法、灸法、针灸、顺势治疗、整骨治疗。\n\t\t\t\t\t（6）任何在中医科、理疗科、康复科进行的治疗。\n\t\t\t\t\t（7）任何妊娠、流产、分娩、不孕不育症、避孕或绝育手术、美容手术、外科整形手术。\n\t\t\t\t\t（8）任何过敏反应、药物过敏或其他医疗导致的伤害。 （9）未取得医生的证明。\n\t\t\t\t"
                      ),
                    ]),
                  ]),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.isMeiYaB(_vm.insureType, _vm.productId)
        ? _c(
            "div",
            [
              _c(
                "el-card",
                {
                  staticStyle: { "margin-top": "20px" },
                  attrs: { header: "投保人声明及确认" },
                },
                [
                  _c("div", { staticClass: "insure_confirm" }, [
                    _vm._v(
                      "\n\t\t\t\t1.本公司/单位兹申请“美亚1-6类团意险（B款）”，并声明以上陈述及各项细节属真实无讹。本公司/单位同意，本投保申请将会构成投保人与美亚财产保险有限公司（以下简称“贵公司”）所签署的保险合同的依据。本公司/单位理解并同意，贵公司承担保险责任须经投保人缴付本合同项下的约定保险费并经贵公司签发保险单确认承保后开始。\n\t\t\t\t2.本公司/单位确认：本公司/单位已经认真阅读保险合同规定，尤其是免除保险人责任的规定，并对贵公司就保险合同的内容说明和提示完全理解，没有异议，申请投保。本公司/单位知晓所有保险责任均以保险合同所载为准。\n\t\t\t\t3.本公司/单位确认：本公司已获得各被保险人的各项同意（包括各被保险人对本保险项下身故保障投保事宜以及保险金额的同意），由本公司为其投保本团体保险；同时本公司/单位同意，如本公司在保险有效期内按约定解除保险合同的，将告知各被保险人。\n\t\t\t\t4.本公司/单位确认：本公司/单位已经认真阅读投保须知中所列的所有投保条件，并如实告知所有投保前提条件；本公司/单位同意，在订立保险合同过程中如未如实填写本投保申请或未如实告知被保险人的有关情况（包括但不限于投保条件的确认），应视为本公司/单位故意未依法履行如实告知义务，由此可能导致该投保无效或贵公司不承担保险责任。\n\t\t\t\t5.本公司/单位同意凡申请投保的员工资料或之后的变更资料，均视为本投保申请的一部分，也是贵公司核保的基础。\n\t\t\t\t6.本公司/单位明白：本公司/单位作为投保人具有支付保险费义务，本公司/单位原则上应通过本公司/单位账户支付保险费，在本公司/单位账户无法支付的情况下将授权本公司/单位员工代为支付保险费。\n\t\t\t\t7.本公司/单位明白：于订立保险合同或因履行保险合同发生争议时，本公司与贵公司协商解决。协商不成的，本公司与贵公司协商一致选择以诉讼或仲裁的方式，解决于订立保险合同或因履行保险合同时发生的争议。\n\t\t\t\t8.本公司/单位确认已阅读并理解贵公司在官网发布的隐私政策（https://www.aig.com.cn/individuals/privacy-notice），同意向所有被保险人获得符合《个人信息保护法》下规定的各项有效同意，以便贵公司根据该隐私政策，处理（包括不限于收集、使用、向境内外第三方提供）被保险人、被保险人所提供的其他个人的个人信息（该信息无论是从投保单还是其他地方获得），以实现该隐私政策中“我们使用个人信息的目的”项下所述的目的。本公司/单位同意，从被保险人处获得的前述有效同意包括就所有下述情形的单独同意：\n\t\t\t\t(1)贵公司根据隐私政策中“我们使用个人信息的目的”项下所述的目的处理个人信息，这些信息可能含有贵公司隐私政策中“我们收集并持有的个人信息”项下所述的敏感个人信息。《个人信息保护法》规定，敏感个人信息包括生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹、不满十四周岁未成年人的个人信息；\n\t\t\t\t(2)贵公司将个人信息披露或提供给贵公司隐私政策中“个人信息的分享方”项下所述的第三方；\n\t\t\t\t(3)贵公司根据贵公司隐私政策中“个人信息处理地点”项下所述在中国境外处理个人信息，并将个人信息提供给隐私政策中“个人信息的分享方”项下所述中国境外的接收方。\n\t\t\t\t如果本公司/单位提供了其他个人的个人信息，我们确认已向其他个人提供了贵公司的隐私政策，并获得了其就贵公司根据隐私政策处理其个人信息的有效同意。所述同意包括在处理其敏感个人信息、向第三方披露其个人信息、向中国境外接收方提供其个人信息以及在中国境外处理其个人信息方面的单独同意。\n\t\t\t\t本公司/单位同时同意，贵公司可按照前述方式和目的处理本公司/单位/和/或被保险人的、与提供保险服务相关的其他信息。\n\t\t\t"
                    ),
                  ]),
                ]
              ),
              _c(
                "el-card",
                {
                  staticStyle: { "margin-top": "20px" },
                  attrs: { header: "责任免除" },
                },
                [
                  _c("div", { staticClass: "insure_confirm" }, [
                    _vm._v(
                      "\n\t\t\t\t本保险适用的主要责任免除如下，其他责任免除条款以与美亚财产保险有限公司正式订立保险合同的规定为准。\n\t\t\t\t"
                    ),
                    _c("div", { staticClass: "title_bold" }, [
                      _vm._v(
                        "\n\t\t\t\t\t美亚团体意外伤害保险（2021年第一版）（互联网专属）（注册编号：C00003932312021121719483）\n\t\t\t\t"
                      ),
                    ]),
                    _vm._v(
                      "\n\t\t\t\t任何在下列期间发生的或由下列原因造成的被保险人的伤害，或出现下列任一情形时，本公司不负任何赔偿责任：\n\t\t\t\t（1）战争、军事行动、暴乱、罢工、武装叛乱或任何形式的恐怖活动。\n\t\t\t\t（2）任何生物、化学、原子能武器，原子能或核能装置所造成的爆炸、灼伤或辐射。\n\t\t\t\t（3）投保人的故意行为；或被保险人无论当时神志是否清醒，自致伤害或自杀。\n\t\t\t\t（4）因被保险人故意行为（见义勇为行为除外）而导致的打斗、被袭击或被谋杀。\n\t\t\t\t（5）被保险人因从事违法犯罪的活动或因拒捕而导致的伤害；以及因遭受司法当局拘禁或被判入狱期间。\n\t\t\t\t（6）被保险人因酗酒或受酒精、毒品、管制药物的影响而导致的意外。 （7）被保险人因精神错乱或失常而导致的意外。\n\t\t\t\t（8）被保险人酒后驾车、无照驾驶或驾驶无有效行驶证的机动交通工具。\n\t\t\t\t（9）被保险人罹患艾滋病（AIDS）或感染艾滋病病毒（HIV）期间（上述定义，应按世界卫生组织所订的定义为准。若在被保险人的血液样本中发现上述病毒或其抗体，则认定已受该病毒感染）。\n\t\t\t\t（10）被保险人置身于任何飞机或空中运输工具（以乘客身份搭乘民用或商业航班者除外）期间。 （11）先天性畸形。\n\t\t\t\t（12）受保前已存在的受伤及其并发症。\n\t\t\t\t（13）被保险人进行赛马、潜水、滑水、滑雪、滑翔翼、跳伞、攀岩运动、摔跤、柔道、空手道、跆拳道、马术、武术、拳击的运动或特技表演。\n\t\t\t\t（14）被保险人参与任何职业或半职业的体育运动。 （15）被保险人进行各种车辆表演、车辆竞赛或练习、驾驶卡丁车。\n\t\t\t\t（16）被保险人于海军、空军、陆军服军役或以警察身份执行任务期间。\n\t\t\t\t（17）被保险人从事采矿业、地下作业、山洞作业、水上作业、五米以上高处作业的职业活动期间。\n\t\t\t\t（18）妊娠、流产、分娩及由此引起的伤害；性传播疾病引起的伤害；美容手术、外科整形手术或其他医疗导致的伤害。\n\t\t\t\t（19）细菌或病毒感染（但因意外伤害致有伤口而发生感染者除外）、食物中毒。\n\t\t\t\t"
                    ),
                    _c("div", { staticClass: "title_bold" }, [
                      _vm._v(
                        "\n\t\t\t\t\t美亚附加意外医药补偿团体医疗保险（2021年第五版）（互联网专属）（注册编号：C00003932522021122436913）\n\t\t\t\t"
                      ),
                    ]),
                    _vm._v(
                      "\n\t\t\t\t主合同中所有责任免除条款均适用于本附加合同，若主合同中责任免除条款与本条款有相抵触之处，则应以本条款为准。任何在下列期间发生的或由下列原因导致的医药费用，本公司不负赔偿责任：\n\t\t\t\t（1）任何原因进行的牙齿保养、牙齿修复、牙齿整形或牙齿植种；非因意外事故进行的任何牙科检查、治疗或手术，以及任何进食活动（包括咀嚼或啃咬）引发的牙科治疗；对非自然牙进行的任何治疗。\n\t\t\t\t（2）屈光不正；任何非因意外事故而进行的眼科检查、视力矫正，以及因矫正视力而作的眼科验光检查。\n\t\t\t\t（3）一般的身体检查（不包括因意外事故进行的牙科和眼科检查）、疗养、特别护理或静养、康复性治疗或心理治疗。\n\t\t\t\t（4）脊椎病。\n\t\t\t\t（5）中草药、中药材或任何传统中医治疗，传统中医治疗包括但不限于推拿、按摩、指压治疗、足科治疗、营养师治疗、理疗、针法、灸法、针灸、顺势治疗、整骨治疗。\n\t\t\t\t（6）任何在中医科、理疗科、康复科进行的治疗。\n\t\t\t\t（7）任何妊娠、流产、分娩、不孕不育症、避孕或绝育手术、美容手术、外科整形手术。\n\t\t\t\t（8）任何过敏反应、药物过敏或其他医疗导致的伤害。 （9）未取得医生的证明。\n\t\t\t\t（10）中国大陆境内医院自主制定价格并在特定区域内提供的特需医疗服务，包括但不限于特需门诊、特需病区、国际医疗、干部病房的相关医疗服务。\n\t\t\t\t（11）中国大陆境内当地社会基本医疗保险管理部门规定全额自费的诊疗项目和药品、检查、治疗、材料等费用，但在境外医院发生的医药费用除外。\n\t\t\t\t"
                    ),
                    _c("div", { staticClass: "title_bold" }, [
                      _vm._v(
                        "\n\t\t\t\t\t美亚附加意外每日住院津贴团体收入保障保险（2021年第一版）（注册编号：C00003931922021072908971）\n\t\t\t\t"
                      ),
                    ]),
                    _vm._v(
                      "\n\t\t\t\t主合同中责任免除条款均适用于本附加合同，若主合同中责任免除条款与本条款有相抵触之处，则应以本条款为准。任何在下列期间发生的，或由下列原因直接、间接地造成被保险人入住医院，或出现下列任一情形时，本公司不负任何赔偿责任：\n\t\t\t\t（1）任何原因进行的牙齿保养、牙齿修复、牙齿整形或牙齿植种；非因意外事故进行的任何牙科检查、治疗或手术，以及任何进食活动（包括咀嚼或啃咬）引发的牙科治疗；对非自然牙进行的任何治疗。\n\t\t\t\t（2）屈光不正；任何非因意外事故而进行的眼科检查、视力矫正，以及因矫正视力而作的眼科验光检查。\n\t\t\t\t（3）一般的身体检查（不包括因意外事故进行的牙科和眼科检查）、疗养、特别护理或静养、康复性治疗或心理治疗。\n\t\t\t\t（4）脊椎病。\n\t\t\t\t（5）中草药、中药材或任何传统中医治疗，传统中医治疗包括但不限于推拿、按摩、指压治疗、足科治疗、营养师治疗、理疗、针法、灸法、针灸、顺势治疗、整骨治疗。\n\t\t\t\t（6）任何在中医科、理疗科、康复科进行的治疗。\n\t\t\t\t（7）任何妊娠、流产、分娩、不孕不育症、避孕或绝育手术、美容手术、外科整形手术。\n\t\t\t\t（8）任何过敏反应、药物过敏或其他医疗导致的伤害。 （9）未取得医生的证明。\n\t\t\t\t"
                    ),
                    _c("div", { staticClass: "title_bold" }, [
                      _vm._v(
                        "\n\t\t\t\t\t美亚附加特种作业限制条款（2021年第二版）（互联网专属）（注册编号：C00003932322021122437203）\n\t\t\t\t"
                      ),
                    ]),
                    _vm._v(
                      "\n\t\t\t\t兹经双方理解并同意，被保险人在保险期间内进行任何特种作业操作前，应依法取得规定的特种作业证书。若被保险人未依法取得规定的特种作业证书而进行特种作业操作的，则对于其因该特种作业操作导致的任何保险事故，本公司不承担任何保险责任。\n\t\t\t\t兹经双方进一步理解并同意，特种作业证书以国家《特种作业人员安全技术培训考核管理规定》规定的为准。\n\t\t\t\t"
                    ),
                    _c("div", { staticClass: "title_bold" }, [
                      _vm._v(
                        "\n\t\t\t\t\t美亚附加特定职业类别人员高处作业条款（2021年第二版）（互联网专属）（注册编号：C00003932322021122437123）\n\t\t\t\t"
                      ),
                    ]),
                    _vm._v(
                      "\n\t\t\t\t兹经双方理解并同意，本合同承保合同约定职业类别为5类和6类的被保险人在从事高处作业的职业活动期间所发生的保险事故。本条款所称的高处作业以《高处作业分级》（中华人民共和国国家标准GB/T3608-2008）中规定的为准，如属于在距坠落高度基准面5米及以上有可能坠落的高处进行作业，前述被保险人应依法取得规定的特种作业证书。为明确起见，特种作业证书以国家《特种作业人员安全技术培训考核管理规定》规定的为准。\n\t\t\t\t兹经双方进一步理解并同意，任何在下列期间发生的意外事故，或出现下列任一情形时，本公司不承担任何保险责任：（1）被保险人从事高处作业时未系绑安全带。（2）被保险人在从事距坠落高度基准面5米及以上高处作业时未取得对应的特种作业证书。\n\t\t\t\t"
                    ),
                    _c("div", { staticClass: "title_bold" }, [
                      _vm._v(
                        "美亚附加不承保特定医院条款（2021年第二版）（注册编号：C00003931922021072908951）"
                      ),
                    ]),
                    _vm._v(
                      "\n\t\t\t\t兹经双方理解并同意，本合同所称的医院不包括：北京市（平谷区、密云区、怀柔区）、天津市（滨海新区、静海区）、福建省南平市、安徽省宿州市、河北省（三河市、廊坊市、青龙县、兴隆县）的所有医院；福建省宁德市古田县医院；河北省承德市第六医院、邯郸市第一医院、馆陶县人民医院、元氏县中医院；河南省（开封市、信阳市、新密市、内黄县、通许县）所有医院，河南省新乡市中医院、新乡市第二人民医院、焦作市第五人民医院、许昌县人民医院、商水县人民医院、濮阳县第二人民医院、鹤壁煤业（集团）有限责任公司总医院；山东省（莱州市、栖霞市、威海市、金乡县、禹城）所有医院，山东滨州市中心医院、鱼台县人民医院、青岛市即墨区中医院、荣成市中医院、烟台市中医医院、聊城市中医医院；四川省宜宾市所有医院、雅安市雨城区人民医院、雅安市第二人民医院、富顺县中医医院、绵阳市人民医院、泸州市纳溪区人民医院、内江市第四人民医院、阿坝州林业中心医院、遂宁市大英县中医院；甘肃省民勤县人民医院、宁县人民医院；山西省运城市盐湖区人民医院；黑龙江鸡西市所有医院，黑龙江省中医医院、牡丹江市中医院、牡丹江市第二人民医院、哈尔滨市第一医院、五大连池市第一人民医院；吉林省四平市所有医院，吉林省中医医院、通化市人民医院、长春市中心医院；辽宁省铁岭市所有医院，辽宁省中医医院；海南省第三人民医院。\n\t\t\t\t"
                    ),
                    _c("div", { staticClass: "title_bold" }, [
                      _vm._v(
                        "美亚附加经济制裁责任免除条款（注册编号：C00003931922019052907382）"
                      ),
                    ]),
                    _vm._v(
                      "\n\t\t\t\t兹经双方理解并同意，若本公司/保险人在本保险合同项下提供任何保险保障、利益或支付任何保险赔偿金会导致本公司/保险人违反联合国决议项下的任何制裁、禁止性或限制性规定，或者违反中华人民共和国或美国颁布的任何经济贸易制裁、法律法规，则本公司/保险人在本保险合同项下不提供前述保险保障、利益，亦不支付前述保险赔偿金。\n\t\t\t\t"
                    ),
                    _c("div", { staticClass: "title_bold" }, [
                      _vm._v(
                        "\n\t\t\t\t\t美亚附加仅承保境内意外事故条款（2021年第二版）（互联网专属）（注册编号：C00003932322021122437063）\n\t\t\t\t"
                      ),
                    ]),
                    _vm._v(
                      "\n\t\t\t\t兹经双方理解并同意，本合同仅承保于境内发生的意外事故。本合同所称的境内是指中国大陆地区，不包括台湾省、香港及澳门特别行政区。\n\t\t\t\t兹经双方进一步理解并同意，本合同所称的医院仅指境内经国家卫生部门评审确定的二级以上（含二级）公立医院，不包括任何精神病院、养老机构、康复医院、诊所、天然治疗所，以及主要作为护理、疗养、戒酒、戒毒或类似目的的医疗机构。\n\t\t\t"
                    ),
                  ]),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }